import type { ToastContentProps } from '@components/ToastContent';
import { PPLSyncStatus } from '@domain/types/ppl-sync-status';

import { PPL_ERROR_MESSAGE } from '../constants';
import type { SuccessStatus } from '../types';

import type { ParsedError } from './error-parsing';
import { extractPathAndMessageFromErrors } from './error-parsing';
import { mapErrorMessage } from './message-mapping';

const mapError = (error: ParsedError) => ({ ...error, message: mapErrorMessage(error.message, error.path) });

interface SuccessToastProps extends ToastContentProps {
  kind?: 'success' | 'info';
}

export const getSuccessToastProps = (message: SuccessStatus): SuccessToastProps | undefined => {
  switch (message) {
    case PPLSyncStatus.SuccessUpdatedLocal:
      return {
        title: 'Data Pulled From PPL',
        description: 'Your changes in PPL have been updated within Contract Builder.',
      };
    case PPLSyncStatus.SuccessUpdatedExternal:
      return {
        title: 'Data Pushed To PPL',
        description: 'Your changes in Contract Builder have been updated within PPL.',
      };
    case PPLSyncStatus.AlreadyInSync:
      return {
        title: 'No Changes Made',
        description: 'Your data is already in sync between Contract Builder and PPL, no updates required.',
        kind: 'info',
      };
  }
};

export const formatErrorMessage = (errors: any[] = []) => {
  const parsedErrors = extractPathAndMessageFromErrors(errors).map(mapError);

  if (parsedErrors.length > 0) {
    return (
      <ul className="flex max-w-[256px] flex-col gap-4 overflow-x-auto">
        <p className="text-info-500 text-sm leading-5 font-normal">{PPL_ERROR_MESSAGE}</p>
        {parsedErrors.map(({ message, path }) => (
          <li key={`${message}-${path}`} className="flex flex-col gap-1 text-sm leading-5">
            {path ? <span className="font-bold">{path.replace(/\./g, ' ')}</span> : null}
            <span>{message}</span>
          </li>
        ))}
      </ul>
    );
  }

  return '';
};
